import { render } from "./OilViscosity.vue?vue&type=template&id=24048ce9"
import script from "./OilViscosity.vue?vue&type=script&lang=js"
export * from "./OilViscosity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__